const filters = document.querySelector( '.content-heading-form__filters' );
const dropdown = document.querySelector( '.content-heading-form__dropdown' );
const overlay = document.querySelector( '.content-heading-form__overlay' );

if ( filters && dropdown && overlay ) {
	filters.addEventListener( 'click', (e) => {
		if ( !e.target.classList.contains('content-heading-form__filters') ) {
			return
		}

		if ( filters.classList.contains('open') ) {
			filters.classList.remove('open');
			closeMenu();
		} else {
			filters.classList.add('open');
			openMenu();
		}
	} );

	overlay.addEventListener( 'click', (e) => {
		if ( filters.classList.contains('open') ) {
			filters.classList.remove('open');
		}

		closeMenu();
	} );

	window.addEventListener( 'resize', () => {
		if ( filters.classList.contains('open') ) {
			filters.classList.remove('open');
		}

		closeMenu();
	} );
}

const toggleMenu = () => {
	dropdown.classList.toggle('open');
	overlay.classList.toggle('show');
}
const openMenu = () => {
	dropdown.classList.add('open');
	overlay.classList.add('show');
}

const closeMenu = () => {
	dropdown.classList.remove('open');
	overlay.classList.remove('show');
}